import React from "react";

import svg from "../../assets/images/icons/hide.svg";

export const HideIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Hide"}
    />
);
